import { Component, HostBinding, OnInit } from '@angular/core';
import { VERIFYSTATE } from '../verify-email/verify-email.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PageContainer } from '../../cockpit/_shared/page-container/page-container';
import { HeaderService } from '../../cockpit/_shared/header/header.service';
import { TranslateService } from '@mono-repo/util';
import { UserService } from '../../cockpit/user/user.service';
import { ConfigService } from '../../config.service';
import { MailingService2 } from '@mono-repo/complex-components';

@Component({
  selector: 'app-set-email',
  templateUrl: './set-email.component.html',
})
export class SetEmailComponent extends PageContainer implements OnInit {
  @HostBinding('class') class = 'dt-c-interactive-dialog';

  public VERIFYSTATE = VERIFYSTATE;

  private token: string | null;
  public isVerified: VERIFYSTATE;
  public errormsg: string;
  public contentReady = false;

  constructor(
    headerService: HeaderService,
    translateService: TranslateService,
    private route: ActivatedRoute,
    private mailingService2: MailingService2,
    private userService: UserService,
    private readonly configService: ConfigService,
    private router: Router,
  ) {
    super(headerService, translateService);
  }

  ngOnInit() {
    this.setTranslateModule('setEmail');

    this.isVerified = VERIFYSTATE.LOADING;
    this.errormsg = '';

    this.token = this.route.snapshot.paramMap.get('token');

    if (this.token) {
      this.mailingService2.setNewEmail(this.token).subscribe(
        () => {
          this.isVerified = VERIFYSTATE.OK;
          this.userService.verifyEmail(true);
          this.contentReady = true;
        },
        () => {
          this.isVerified = VERIFYSTATE.ERROR;
          // this.errormsg was not used in any logik or ui. If you want to use it, you have to prepare the error since its an object now
          //this.errormsg = error;
          //console.error(error);
          this.contentReady = true;
        },
      );
    } else {
      this.isVerified = VERIFYSTATE.ERROR;
      console.error('No token found!');
      this.contentReady = true;
    }
  }

  public routeToLogin(): void {
    if (this.configService.getConfig().initialRoute) {
      this.router.navigate([`/${this.configService.getConfig().initialRoute}`]);
    } else {
      this.router.navigate(['/login']);
    }
  }
}
